import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegistrationNumberStep from './RegistrationNumberStep';
import CodeEntryStep from './CodeEntryStep';

const STEPS = {
  REGISTRATION_NUMBER: 'registrationNumber',
  CODE: 'code',
};

/**
 * PIV self-service claim flow (ADR va.gov-team-sensitive #6219). Shown instead of the standard
 * "we can't verify your accreditation" message when the backend reports the signed-in PIV/Entra
 * user is eligible to link their own accreditation record: they enter their registration number,
 * then a one-time code sent to the email GCLAWS has on file for it.
 */
const PivSelfClaim = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(STEPS.REGISTRATION_NUMBER);
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [individualType, setIndividualType] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');

  const handleCodeSent = ({
    registrationNumber: number,
    individualType: type,
    maskedEmail: email,
  }) => {
    setRegistrationNumber(number);
    setIndividualType(type);
    setMaskedEmail(email);
    setStep(STEPS.CODE);
  };

  const handleLinked = () => {
    // Full client-side navigation: drops the `?unauthorized` param and re-runs the
    // dashboard loader, which now resolves the user through the ICN lookup.
    navigate('/dashboard', { replace: true, state: { pivClaimLinked: true } });
  };

  if (step === STEPS.CODE) {
    return (
      <CodeEntryStep
        registrationNumber={registrationNumber}
        individualType={individualType}
        maskedEmail={maskedEmail}
        onLinked={handleLinked}
      />
    );
  }

  return (
    <RegistrationNumberStep
      onCodeSent={handleCodeSent}
      onLinked={handleLinked}
    />
  );
};

export default PivSelfClaim;
